import { Command, HttpMethod } from "~/extensions/api";
export class GetLatestNyukyoCommand extends Command {
    constructor(isForceGetLatest) {
        super(HttpMethod.Get, "latest/nyukyo/get");
        this.isForceGetLatest = isForceGetLatest;
    }
    isForceGetLatest = false;
}
